export default "__VITE_ASSET__DoAY7EGZ__"